<template>

    <b-container class="bv-example-row" style="margin-bottom:64px; min-height:50vh">
        <b-row class="mt-5 mb-5">
            <b-col>
                <h1
                    v-if="!nameEdit"
                    style="
                        font-size: 2rem;
                        cursor: pointer;
                        width: fit-content;
                        text-align: center;
                        margin-left: auto;
                        margin-right: auto;
                        margin-bottom: 1rem;
                    "
                    v-b-tooltip.hover.right title="Click me to change my name."
                    @click="edit_name(true)"
                >{{account.name}}</h1>
                <b-form @submit.prevent="update_account" v-else inline style="width:480px; margin:auto" class="mb-4">
                    <b-input style="width:240px; margin-left:220px; margin-right:10px" v-model="account.name"/>
                    <b-button
                        type="submit"
                        variant="primary"
                        style="margin-right:5px"
                        :disabled="edit_buttons_disabled"
                    >Save</b-button>
                    <b-button variant="outline-dark" @click="edit_name(false)" :disabled="edit_buttons_disabled">X</b-button>
                </b-form>
            </b-col>
        </b-row>

        <b-row class="mt-5 mb-5">
            <b-col>

                <b-tabs fill v-model="tabIndex">
                    <b-tab title="Users">
                        <b-row class="mt-4 mb-2">
                            <b-col class="text-right mr-4">
                                <b-link
                                    id="create-user-link"
                                    @click="toggle_create_user_modal"
                                >Create User</b-link>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="mx-4">
                                <b-table :items="users" :fields="user_fields" striped show-empty>
                                    <template v-slot:cell(action)="item">
                                        <b-link @click="select_user(item.item)"> Edit </b-link> -
                                        <b-link @click="request_delete(item.item)"> Delete </b-link>
                                    </template>
                                </b-table>
                            </b-col>
                        </b-row>
                    </b-tab>

                    <b-tab title="Address">
                        <b-row class="mt-4 mb-2">
                            <b-col class="text-right mr-4">
                                <b-link
                                    id="edit-address-link"
                                    @click="toggle_address_modal"
                                >Edit Address</b-link>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="mx-4">
                                <b-table :items="address" :fields="address_fields" show-empty stacked>
                                    <template v-slot:cell(state)="item">
                                        {{
                                            stateOptions.find(({ value }) => value === item.value)
                                            ?   stateOptions.find(({ value }) => value === item.value).text
                                            :   null
                                        }}
                                    </template>
                                </b-table>
                            </b-col>
                        </b-row>
                    </b-tab>
                </b-tabs>

            </b-col>
        </b-row>

        <b-modal id="modal-create-user" title="New User" size="lg" v-model="modal_create_user">
            <template v-slot:modal-header-close>
                <b-button size="sm" class="close" variant="null" @click="toggle_create_user_modal">x</b-button>
            </template>
            <b-form @submit.prevent="register">
                <b-form-group label="Email:" label-for="input-1">
                    <b-form-input id="input-1" v-model="new_user.email" type="text" required/>
                </b-form-group>
                <b-form-group label="First Name:" label-for="input-2">
                    <b-form-input id="input-2" v-model="new_user.first_name" type="text" required/>
                </b-form-group>
                <b-form-group label="Last Name:" label-for="input-3">
                    <b-form-input id="input-3" v-model="new_user.last_name" type="text" required/>
                </b-form-group>
                <b-form-group label="Password:" label-for="input-4">
                    <b-form-input id="input-4" v-model="new_user.password" type="password" required/>
                </b-form-group>
            </b-form>
            <template v-slot:modal-footer="{ ok }">
                <b-button variant="dark" @click="create_user"  class="mr-4 my-2"> Save </b-button>
            </template>
        </b-modal>

        <b-modal id="modal-edit-user" title="Edit User" size="lg" v-model="modal_edit_user">
            <template v-slot:modal-header-close>
                <b-button size="sm" class="close" variant="null" @click="toggle_edit_user_modal">x</b-button>
            </template>
            <b-form @submit.prevent="register">
                <b-form-group label="Email:" label-for="input-1a">
                    <b-form-input id="input-1a" v-model="updated_user.email" type="text" required/>
                </b-form-group>
                <b-form-group label="First Name:" label-for="input-2a">
                    <b-form-input id="input-2a" v-model="updated_user.first_name" type="text" required/>
                </b-form-group>
                <b-form-group label="Last Name:" label-for="input-3a">
                    <b-form-input id="input-3a" v-model="updated_user.last_name" type="text" required/>
                </b-form-group>
            </b-form>
            <template v-slot:modal-footer="{ ok }">
                <b-button variant="dark" @click="edit_user"  class="mr-4 my-2"> Save </b-button>
            </template>
        </b-modal>

        <b-modal id="modal-edit-address" title="Edit Address" size="lg"  v-model="modal_edit_address">
            <template v-slot:modal-header-close>
                <b-button size="sm" class="close" variant="null" @click="toggle_address_modal">x</b-button>
            </template>
            <b-form @submit.prevent="register">
                <b-form-group label="Address Line 1:" label-for="input-1b">
                    <b-form-input id="input-1b" v-model="address[0].line_1" type="text" required/>
                </b-form-group>
                <b-form-group label="Address Line 2:" label-for="input-1b">
                    <b-form-input id="input-1b" v-model="address[0].line_2" type="text" required/>
                </b-form-group>
                <b-form-group label="City:" label-for="input-2b">
                    <b-form-input id="input-2b" v-model="address[0].city" type="text" required/>
                </b-form-group>
                <b-form-group label="State:">
                    <b-form-select required v-model="address[0].state" :options="stateOptions" id="3-b"/>
                </b-form-group>
                <b-form-group label="Zip Code:" label-for="input-4b">
                    <b-form-input id="input-4b" v-model="address[0].zip" type="email" required/>
                </b-form-group>
            </b-form>
            <template v-slot:modal-footer="{ ok }">
                <b-button variant="dark" @click="edit_address" class="mr-4 my-2"> Save </b-button>
            </template>
        </b-modal>

    </b-container>

</template>


<script>

    import { stateOptions } from '../config/address'

    const confirmation_box_config = {
        title: 'Confirm Deletion',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
    }

    export default {
        name: 'account-info',

        props:{
            modal_create_user: {type: Boolean},
            modal_edit_user: {type: Boolean},
            modal_edit_address: {type: Boolean},

            nameEdit: {type: Boolean},
            edit_buttons_disabled: {type: Boolean},

            account:{ type: Object},
            address: { type: Array},
            address_fields: { type: Array},

            users: { type: Array},
            user_fields: { type: Array},

            new_user: { type: Object},
            updated_user: { type: Object}
        },

        data(){
            return {
                tabIndex: 0,
                stateOptions: stateOptions
            }
        },

        methods:{

            toggle_create_user_modal(){this.$emit('toggle_create_user_modal')},
            toggle_edit_user_modal(){this.$emit('toggle_edit_user_modal')},
            toggle_address_modal(){this.$emit('toggle_address_modal')},

            edit_name(bool){ this.$emit('edit_name', bool)},
            select_user(user){  this.$emit('select_user', user)},

            async get_account(account_id){ this.$emit('get_account', account_id)},
            async update_account(){ this.$emit('update_account')},

            async get_users(){ this.$emit('get_users')},
            async create_user(){ this.$emit('create_user')},
            async edit_user(){ this.$emit('edit_user')},
            async delete_user(user){ this.$emit('delete_user', user)},

            async get_address(){ this.$emit('get_address')},
            async edit_address(){ this.$emit('edit_address')},

            async request_delete(user){
                const value = await this.$bvModal.msgBoxConfirm(
                    this.$createElement('div',{ domProps:{
                        innerHTML: `<p>Are you sure you want to delete user <b>${user.first_name} ${user.last_name}</b>?</p>`
                    } }),
                    confirmation_box_config
                )
                value ? this.delete_user(user) : null
            }
        }
    }

</script>
